import React from "react";
import { useParams } from "react-router-dom";

import PageSecondaryNavigation, {
  PageNavLink,
} from "ui/PageSecondaryNavigation";
import { useAppConfig } from "providers/WithAppConfig";
import { useRoutes } from "utils/routes";
import { useCurrentOrganization } from "providers/WithCurrentOrganization";

const SettingsNav: React.FunctionComponent = () => {
  const { enterpriseEdition } = useAppConfig();
  const currentOrganization = useCurrentOrganization();
  const { slug: organizationSlug } = currentOrganization;
  const serverGroupCrudEnabled =
    currentOrganization.enabledFeatures.serverGroupCrud;
  const { serverId, serverGroupId } = useParams();
  const {
    collectorSettings,
    serverEdit,
    serverGroupEdit,
    organizationServersSettings,
    organizationServerGroupsSettings,
    organizationMembers,
    organizationRoles,
    organizationApi,
    organizationSubscription,
    organizationEdit,
    organizationIntegrations,
  } = useRoutes();
  const containingGroup = serverGroupId
    ? currentOrganization.serverGroups.find((sg) => sg.id === serverGroupId) ??
      (currentOrganization.customServerGroups.find(
        (sg) => sg.id === serverGroupId,
      ) as unknown as
        | (typeof currentOrganization.serverGroups)[number]
        | undefined)
    : serverId
    ? currentOrganization.serverGroups.find((sg) =>
        sg.servers.some((s) => s.humanId === serverId),
      )
    : undefined;
  const clusterPrimaryHumanId = containingGroup?.primaryServerHumanId;
  const serverSettingsTarget = serverId
    ? serverEdit(serverId)
    : clusterPrimaryHumanId
    ? serverEdit(clusterPrimaryHumanId)
    : organizationServersSettings(organizationSlug);
  return (
    <PageSecondaryNavigation>
      {containingGroup || serverGroupCrudEnabled ? (
        <PageNavLink
          to={
            containingGroup
              ? serverGroupEdit(containingGroup.id)
              : organizationServerGroupsSettings(organizationSlug)
          }
        >
          Server Group Settings
        </PageNavLink>
      ) : null}
      <PageNavLink to={serverSettingsTarget}>Server Settings</PageNavLink>
      {serverId ? (
        <PageNavLink to={collectorSettings(serverId)}>
          Collector Settings
        </PageNavLink>
      ) : null}
      <PageNavLink to={organizationMembers(organizationSlug)}>
        Members
      </PageNavLink>
      <PageNavLink to={organizationRoles(organizationSlug)}>
        Member Roles
      </PageNavLink>
      <PageNavLink to={organizationApi(organizationSlug)}>
        API Access
      </PageNavLink>
      {!enterpriseEdition && (
        <PageNavLink
          to={organizationSubscription(organizationSlug)}
          end={false}
        >
          Billing
        </PageNavLink>
      )}
      <PageNavLink to={organizationIntegrations(organizationSlug)}>
        Integrations
      </PageNavLink>
      <PageNavLink to={organizationEdit(organizationSlug)}>
        Other Settings
      </PageNavLink>
    </PageSecondaryNavigation>
  );
};

export default SettingsNav;
